<div class="fullscreen-viewer h-100 d-flex flex-column">
  <div class="fullscreen-viewer-topbar">
    <button type="button" class="fullscreen-viewer-close" (click)="close()"
      [attr.aria-label]="'Button.Close' | translate">
      <i class="bi bi-x-lg" aria-hidden="true"></i>
    </button>
    <span class="fullscreen-viewer-pagecounter">
      {{ 'Request.View.PerformActionFullscreenViewer.Page' | translate }} {{currentPageId}}/{{totalPages}}
    </span>
  </div>
  <div class="fullscreen-viewer-content" #viewport (pointerdown)="onPointerDown($event)"
    (pointermove)="onPointerMove($event)" (pointerup)="onPointerUp($event)" (pointercancel)="onPointerUp($event)">
    <div class="fullscreen-viewer-page" [style.aspectRatio]="aspectRatio"
      [style.transform]="'translate(' + translateX + 'px, ' + translateY + 'px) scale(' + scale + ')'">
      @if (!isPageRendered()) {
        <canvas class="fullscreen-viewer-image"></canvas>
      }
      @if (isPageRendered()) {
        <img [src]="getCurrentPageUrl()" alt="Page{{currentPageId}}" class="fullscreen-viewer-image">
      }
    </div>
  </div>
  <button type="button" class="fullscreen-viewer-fit-button" (click)="fitToScreen()"
    translate="Request.View.PerformActionFullscreenViewer.FitToScreen"></button>
</div>
